<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <v-toolbar-title>Несохраненные заявки</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>


        </v-toolbar>

        <v-data-table
                :headers="headers"
                :items="unsavedRequests"
                :pagination.sync="pagination"
                :light=true
                no-data-text=""
                rows-per-page-text="Строк на странице"
                :rows-per-page-items='[ 15, 30, 50, { "text": "все", "value": -1 }]'
                class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td @dblclick="request_info(props.item)">{{ props.item.changeDate }}</td>
                <td class="right layout px-0">


                    <v-tooltip top>
                        <v-btn slot="activator" color="primary" flat icon @click="request_info(props.item)">
                            <v-icon small>fa-pencil</v-icon>
                        </v-btn>
                        <span >Редактировать заявку</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" color="red" flat icon @click="deleteItem(props.item)">
                        <v-icon small>fa-trash</v-icon>
                        </v-btn>
                        <span>Delete заявку</span>
                    </v-tooltip>

                </td>
            </template>

        </v-data-table>

        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>
    </v-container>
</template>
<script>
    import Vue from 'vue'

    export default{

        data: () => ({
            unsavedKeys: [],
            unsavedRequests: [],
            headers: [
                { text: 'Номер заявки',value: 'id', sortable: false},
                { text: 'Действия',align: 'center',class: 'flight-actions', sortable: false }
            ],
            pagination: {},

        }),

        computed: {

            pages () {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0
                return Math.ceil(this.unsavedRequests.length / this.pagination.rowsPerPage)
            },

        },

        beforeDestroy () {

        },
        created () {
            this.unsavedKeys = this.$route.params.item
            this.getUnsavedRequests();

        },

        methods: {
            getUnsavedRequests(){
                let arr = this.unsavedRequests
                let date = this.convertDateTime
                for(let i = 0; i < this.unsavedKeys.length; i++){
                    this.$getItem(this.unsavedKeys[i]).then(function(value) {
                        arr.push(value)
                        for(let i = 0; i < arr.length; i++){
                            Vue.set(arr[i], 'changeDate', date(arr[i].changeDate))
                        }
                    })
                }
            },

            deleteItem (item) {

                const index = this.unsavedRequests.indexOf(item)

                if(confirm('Вы уверены, что хотите удалить эту заявку ?')) {
                    let splice = this.unsavedRequests.splice(index, 1)
                    this.$removeItem(item.keyValue).then(function() {
                        splice
                    })
                }
            },

            request_info(item){
                this.$router.push({ name: 'unsavedRequest', params: { item: item, id: item.keyValue } })
            },

            convertDateTime(date){
               if(date) {
                   let date2 = new Date(date);
                   let year = date2.getFullYear();
                   let month = ("0" + (date2.getMonth() + 1)).slice(-2);
                   let day = ("0" + date2.getDate()).slice(-2);
                   let hours = ("0" + date2.getHours()).slice(-2);
                   let minutes = ("0" + date2.getMinutes()).slice(-2);

                   return year + '-' + month + '-' + day + ' ' +  hours + ':' + minutes;
               }

            },

        }

    }
</script>
<style>
</style>